import React, { useState } from 'react';
import './FAQSection.css';
import { FaChevronDown, FaQuestionCircle } from 'react-icons/fa';

const faqs = [

        {
          question: "What services does Novacrest offer?",
          answer:
            "Novacrest provides end-to-end digital solutions, including AI-powered platforms, custom software development, cloud infrastructure, mobile applications, enterprise systems, and managed IT services—all designed for scalability, security, and high performance.",
        },
        {
          question: "How does the Novacrest Methodology work?",
          answer:
            "Our proprietary methodology follows a structured, data-driven approach: pattern identification, user mapping, UI/UX wireframing, model development, and full-scale deployment. It ensures consistent delivery, rapid iteration, and business alignment.",
        },
      
          {
          question: "Can you build custom AI tools for my business?",
          answer:
            "Absolutely. We specialize in developing AI solutions tailored to your industry, such as: Predictive analytics -Computer vision -Natural language processing (NLP) -Recommendation engines -Intelligent automation",
        },
        {
          question: "How do you ensure your solutions align with First Nations' cultural and regulatory needs?",
          answer:
            "We engage in consultative partnerships with First Nations communities, incorporating cultural considerations and adhering to Indigenous data sovereignty principles, legal frameworks, and industry-specific regulations.",
        },
       
        {
          question: "What industries do you serve?",
          answer:
           "We partner with First Nations clients in Canada across multiple sectors, including healthcare, finance, logistics, retail, education, and manufacturing. Our solutions meet strict compliance, security, and performance standards."
        },
         {
          question: "What’s your approach to data privacy, especially in healthcare or finance?",
          answer:
           "We implement role-based access controls, data anonymization, and compliance with PIPEDA, HIPAA, or FINRA (as applicable), along with end-to-end encryption for sensitive data."
        },
        {
          question: "What cloud platforms do you work with?",
          answer:
            "We have expertise in AWS, Microsoft Azure, Google Cloud, and hybrid environments, delivering scalable, secure, and cost-optimized cloud architectures for businesses of all sizes.",
        },
        {
          question: "Do you provide post-launch support and maintenance?",
          answer:
            "Yes, we offer comprehensive post-launch support including bug fixes, performance tuning, version upgrades, and long-term maintenance contracts with SLAs to ensure reliability.",
        },
        {
          question: "How secure are your solutions?",
          answer:
            "Security is integrated at every stage—from design to deployment. We adhere to OWASP guidelines, secure coding practices, encryption, access controls, and regular audits to protect your data and infrastructure.",
        },
     
      
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-header">
        <FaQuestionCircle className="faq-icon" color='8f69c8' />
        <h2>Frequently Asked Questions</h2>
        <p>Everything you need to know about our services and process.</p>
      </div>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            className={`faq-card ${activeIndex === index ? 'active' : ''}`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h4>{faq.question}</h4>
              <FaChevronDown className={`arrow ${activeIndex === index ? 'rotated' : ''}`} />
            </div>
            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
